import styled from '@emotion/styled';
import Footer from './Footer';
import { Box, Theme, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import StoreLogoThumbnailAtTop from './StoreLogoThumbnailAtTop';

const LayoutContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh'
});

const ContentContainer = styled(Box)({
  flex: '1 0 auto'
});

type RegisterProps = {
  inviteSite?: string;
  storeLogoThumbnail?: string;
  children: React.ReactNode;
};

const RegisterLayoutWithoutHeader: React.FC<RegisterProps> = ({
  inviteSite: externalInviteSite,
  storeLogoThumbnail,
  children
}) => {
  const { pathname } = useLocation();
  const isSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

  const sxMargin = isSmall
    ? {
        mt: 5,
        mb: 5,
        ml: 2,
        mr: 2
      }
    : {
        mt: 10,
        mb: 10,
        ml: 3,
        mr: 3
      };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <LayoutContainer
      sx={{
        backgroundColor: '#FFFFFF',
        '& .MuiBox-root': {
          marginTop: 0
        },
        '& .MuiContainer-root': {
          padding: 0
        }
      }}
    >
      <StoreLogoThumbnailAtTop storeLogoThumbnail={storeLogoThumbnail} inviteSite={externalInviteSite} />
      <ContentContainer sx={sxMargin}>{children}</ContentContainer>
      <Footer inviteSite={externalInviteSite} />
    </LayoutContainer>
  );
};

export default RegisterLayoutWithoutHeader;
